import { CommonEnums } from 'src/app/shared/common.enums';

export class Venn_Unon_Inst {
    venn_Unon_Inst_Id: number;
    dxMp_Id: number;
    nm: string;
    description: string;
    ver: string;
    valid_Cd: string;
    persistFlg: string;
    updateDt: Date;
    updateBy: string;
    lastUpdateBy: string;
    prop_Tab_Valid_Cd: string;
    attr_Tab_Valid_Cd: string;
    primObjId: number;
    havingClause: string;
    havingClauseValid_Cd: string;

    constructor() {
        this.setDefaults()
    }

    setDefaults(): void {
        this.venn_Unon_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
        this.persistFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.updateDt = new Date();
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.prop_Tab_Valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
        this.attr_Tab_Valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
        this.primObjId = CommonEnums.defaults.LONG_VAL;
    }

    static parse(venn_Unon_InstTmp: Venn_Unon_Inst): Venn_Unon_Inst {
        let venn_Unon_Inst: Venn_Unon_Inst = new Venn_Unon_Inst();
        venn_Unon_Inst.copyFrom(venn_Unon_InstTmp);
        return venn_Unon_Inst;
    }

    getPrimaryKey(): string {
        return this.venn_Unon_Inst_Id + '.' + this.dxMp_Id;
    }

    copy(): Venn_Unon_Inst {
        let venn_Unon_InstTmp: Venn_Unon_Inst = new Venn_Unon_Inst();

        venn_Unon_InstTmp.venn_Unon_Inst_Id = this.venn_Unon_Inst_Id;
        venn_Unon_InstTmp.dxMp_Id = this.dxMp_Id;
        venn_Unon_InstTmp.nm = this.nm;
        venn_Unon_InstTmp.description = this.description;
        venn_Unon_InstTmp.ver = this.ver;
        venn_Unon_InstTmp.valid_Cd = this.valid_Cd;
        venn_Unon_InstTmp.persistFlg = this.persistFlg;
        venn_Unon_InstTmp.updateDt = this.updateDt;
        venn_Unon_InstTmp.updateBy = this.updateBy;
        venn_Unon_InstTmp.lastUpdateBy = this.lastUpdateBy;
        venn_Unon_InstTmp.prop_Tab_Valid_Cd = this.prop_Tab_Valid_Cd;
        venn_Unon_InstTmp.attr_Tab_Valid_Cd = this.attr_Tab_Valid_Cd;
        venn_Unon_InstTmp.primObjId = this.primObjId;

        return venn_Unon_InstTmp;
    }

    copyFrom(venn_Unon_InstTmp: Venn_Unon_Inst): void {
        this.venn_Unon_Inst_Id = venn_Unon_InstTmp.venn_Unon_Inst_Id;
        this.dxMp_Id = venn_Unon_InstTmp.dxMp_Id;
        this.nm = venn_Unon_InstTmp.nm;
        this.description = venn_Unon_InstTmp.description;
        this.ver = venn_Unon_InstTmp.ver;
        this.valid_Cd = venn_Unon_InstTmp.valid_Cd;
        this.persistFlg = venn_Unon_InstTmp.persistFlg;
        this.updateDt = venn_Unon_InstTmp.updateDt;
        this.updateBy = venn_Unon_InstTmp.updateBy;
        this.lastUpdateBy = venn_Unon_InstTmp.lastUpdateBy;
        this.prop_Tab_Valid_Cd = venn_Unon_InstTmp.prop_Tab_Valid_Cd;
        this.attr_Tab_Valid_Cd = venn_Unon_InstTmp.attr_Tab_Valid_Cd;
        this.primObjId = venn_Unon_InstTmp.primObjId;
    }

    compare(venn_Unon_InstTmp: Venn_Unon_Inst): string {
        let venn_Unon_InstString: string = this.toString(false);
        let venn_Unon_InstTmpString: string = venn_Unon_InstTmp.toString(false);

        if (venn_Unon_InstString != venn_Unon_InstTmpString) {
            return venn_Unon_InstString + ', ' + venn_Unon_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Venn_Unon_Inst [venn_Unon_Inst_Id=" + this.venn_Unon_Inst_Id + ", dxMp_Id=" + this.dxMp_Id +
            ", nm=" + this.nm + ", description=" + this.description + ", ver=" + this.ver + ", valid_Cd=" + this.valid_Cd +
            ", persistFlg=" + this.persistFlg + ", updateDt=" + this.updateDt + ", updateBy=" + this.updateBy +
            ", lastUpdateBy=" + this.lastUpdateBy + ", prop_Tab_Valid_Cd=" + this.prop_Tab_Valid_Cd +
            ", attr_Tab_Valid_Cd=" + this.attr_Tab_Valid_Cd + ", primObjId=" + this.primObjId;

        if (isNotCompare) {
            str += ''
        }

        str += ']';

        return str;
    }
}